import React from "react";
import { connect } from "react-redux";
import UserSelect from "./UserSelect";
import { getDataComponentFlattenedRequestState } from "../../../../reducers/dataComponentReducer";
import { consultingDCId } from "../../../inputs/inputConfigs/projects";
import { getBluechipResources } from "../../../../utils/bluechipUtils";

const invoiceSubmissionsType = "Invoice Submissions";
const projectManagerType = "Project Manager";

const InvoiceSubmissionSelect = props => {
  return <UserSelect {...props} />;
};

export const mapStateToProps = () => {
  return (state, { consultingCompanyId, secondaryConsultingCompanyId }) => {
    const dataComponent = getDataComponentFlattenedRequestState(
      consultingDCId,
      state
    );

    const consultingCompanies =
      getBluechipResources(dataComponent, state) || [];

    const getCompanyContacts = companyId => {
      if (!companyId) return [];
      return (
        consultingCompanies
          .find(
            company =>
              company.type === projectManagerType && company.id === companyId
          )
          ?.consultingCompanyContacts?.map(member => ({
            contactId: member.contactId,
            name: member.contact.name,
            memberType: invoiceSubmissionsType,
          })) ?? []
      );
    };

    const memberContacts = [
      ...getCompanyContacts(consultingCompanyId),
      ...getCompanyContacts(secondaryConsultingCompanyId),
    ];

    return {
      additionalOptions: memberContacts,
    };
  };
};

export default connect(mapStateToProps)(InvoiceSubmissionSelect);
